import {Box, IconButton, Typography, useTheme} from '@mui/material';
import {SidePopupProps} from '../index';
import {Image} from '@jobseeker/lotus/components/Image';
import Slide from '@mui/material/Slide';
import {ChevronDown as ChevronUp, WhiteChevronDown} from '@jobseeker/lotus/icons';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export default ({sx, imgUrl, show, ...props}: SidePopupProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: '#fff',

        width: '360px',
        position: 'absolute',
        boxShadow: '0px 0px 10px 0px #7E7E7E4D',
        borderRadius: '16px 16px 0 0',
        overflow: 'hidden',
        right: theme.spacing(1.5),
        bottom: 0,
        zIndex: '900',
        transition: '0.3s ease',
        ...sx,
      }}
      {...props}
      boxShadow={2}
    >
      <Box
        sx={{
          backgroundColor: isAppIimjobs ? 'prompt.light' : '#13355c',
          py: {xxs: 1.5},
          pt: 2,
          pl: {xxs: 1.5, md: '29px'},
          pr: {xxs: 1.5, md: '22px'},
        }}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'flex-start'}
        width={'100%'}
      >
        {imgUrl && <Image src={imgUrl} alt={''} />}
        <Box width={'100%'}>
          {props.title ||
            (props.heading && (
              <Typography
                lineHeight={'18px'}
                variant="subtitle2"
                sx={{color: isAppIimjobs ? '#333' : 'white'}}
              >
                {props.title || props.heading}
              </Typography>
            ))}
          {props.subtitle && typeof props.subtitle === 'string' ? (
            <Typography variant="body3">{props.subtitle}</Typography>
          ) : (
            <>{props.subtitle}</>
          )}
        </Box>
        <IconButton onClick={props.onToggle ? props.onToggle : console.log}>
          <Image
            // component={Image}
            src={isAppIimjobs ? ChevronUp : WhiteChevronDown}
            width={16}
            height={16}
            alt={''}
            style={{
              transform: !show ? 'rotate(-180deg)' : 'unset',
              transition: '0.3 ease',
            }}
          />
        </IconButton>
      </Box>
      {show && (
        <>
          <Box
            sx={{
              backgroundColor: isAppIimjobs ? 'prompt.light' : '#13355c',
              height: 60,
              borderRadius: '0 0 16px 16px',
            }}
          ></Box>
          <Box
            mx={2}
            mt={-8}
            sx={{
              backgroundColor: '#fff',
              border: '1px solid #7E7E7E33',
              borderRadius: '20px',
              overflow: 'hidden',
            }}
            mb={2.5}
          >
            <Box>{props.children}</Box>
          </Box>
        </>
      )}
    </Box>
  );
};
